/**
 * Checks if the activity id for the product is set
 * If not, redirect to Step 1 of that flow.
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct<ProductActivity>(to);
    const { firstStepRoute } = useFlow(to);

    if (!product.value.activityId) {
        return navigateTo(firstStepRoute.value);
    }
});
